module.exports = __webpack_public_path__ + "img/mc.77467ef6.jpg";